<div class="rounded-[20px] border-2 border-background-white bg-background-white p-6 backdrop-blur">
  <h4 class="typo-h4-medium mb-4 text-center">
    {{ 'schedule_delete_appointment_modal_title' | translate }}
  </h4>

  <h5 class="typo-h5-book mb-4 text-center text-text-secondary">
    {{ 'schedule_delete_appointment_modal_description' | translate }}
  </h5>

  <hr class="mb-4 h-[1px] w-full text-text-white" />

  <div class="flex gap-x-4">
    <button type="button" class="btn-secondary h-10 w-full justify-center" (click)="onCloseDialog()">
      {{ 'schedule_delete_appointment_modal_cancel' | translate }}
    </button>
    <button type="button" class="btn-primary h-10 w-full justify-center" (click)="onDeleteAppointmentClick()">
      {{ 'schedule_delete_appointment_modal_delete' | translate }}
    </button>
  </div>
</div>
